import { assert_string_object_id, assert_type_enum } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class RequestGrid2dDownloadImages extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_GRID2D_DOWNLOAD_IMAGES;

  /*
   * FIELDS
   */
  workspace_id!: string;
  entity_type!: string;
  entity_id!: string;
  grid2d_id!: string;

  /*
   * METHODS
   */

  assert_standard_fields(): void {
    assert_string_object_id(this.workspace_id);
    assert_type_enum(this.entity_type, ENUM__workspace_entity);
    assert_string_object_id(this.entity_id);
    assert_string_object_id(this.grid2d_id);
  }
}
